//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Multiselect } from '@nextcloud/vue';
import marked from 'marked';
import dompurify from 'dompurify';
import AppScore from './AppList/AppScore';
import AppManagement from './AppManagement';
import PrefixMixin from './PrefixMixin';
import SvgFilterMixin from './SvgFilterMixin';
export default {
  name: 'AppDetails',
  components: {
    Multiselect: Multiselect,
    AppScore: AppScore
  },
  mixins: [AppManagement, PrefixMixin, SvgFilterMixin],
  props: ['category', 'app'],
  data: function data() {
    return {
      groupCheckedAppsData: false
    };
  },
  computed: {
    appstoreUrl: function appstoreUrl() {
      return "https://apps.nextcloud.com/apps/".concat(this.app.id);
    },
    licence: function licence() {
      if (this.app.licence) {
        return t('settings', '{license}-licensed', {
          license: ('' + this.app.licence).toUpperCase()
        });
      }

      return null;
    },
    hasRating: function hasRating() {
      return this.app.appstoreData && this.app.appstoreData.ratingNumOverall > 5;
    },
    author: function author() {
      if (typeof this.app.author === 'string') {
        return [{
          '@value': this.app.author
        }];
      }

      if (this.app.author['@value']) {
        return [this.app.author];
      }

      return this.app.author;
    },
    appGroups: function appGroups() {
      return this.app.groups.map(function (group) {
        return {
          id: group,
          name: group
        };
      });
    },
    groups: function groups() {
      return this.$store.getters.getGroups.filter(function (group) {
        return group.id !== 'disabled';
      }).sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    },
    renderMarkdown: function renderMarkdown() {
      var renderer = new marked.Renderer();

      renderer.link = function (href, title, text) {
        var prot;

        try {
          prot = decodeURIComponent(unescape(href)).replace(/[^\w:]/g, '').toLowerCase();
        } catch (e) {
          return '';
        }

        if (prot.indexOf('http:') !== 0 && prot.indexOf('https:') !== 0) {
          return '';
        }

        var out = '<a href="' + href + '" rel="noreferrer noopener"';

        if (title) {
          out += ' title="' + title + '"';
        }

        out += '>' + text + '</a>';
        return out;
      };

      renderer.image = function (href, title, text) {
        if (text) {
          return text;
        }

        return title;
      };

      renderer.blockquote = function (quote) {
        return quote;
      };

      return dompurify.sanitize(marked(this.app.description.trim(), {
        renderer: renderer,
        gfm: false,
        highlight: false,
        tables: false,
        breaks: false,
        pedantic: false,
        sanitize: true,
        smartLists: true,
        smartypants: false
      }), {
        SAFE_FOR_JQUERY: true,
        ALLOWED_TAGS: ['strong', 'p', 'a', 'ul', 'ol', 'li', 'em', 'del', 'blockquote']
      });
    }
  },
  mounted: function mounted() {
    if (this.app.groups.length > 0) {
      this.groupCheckedAppsData = true;
    }
  }
};